/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  SET_SPEAKERS (state, speakers) {
    state.speakers = speakers
  },
  REMOVE_RECORD (state, itemId) {
    const speakerIndex = state.speakers.findIndex((u) => u.Email === itemId)
    state.speakers.splice(speakerIndex, 1)
  }
}
